import { render, staticRenderFns } from "./BbppDigitalPlatformsAS.vue?vue&type=template&id=c487cf52"
import script from "./BbppDigitalPlatformsAS.vue?vue&type=script&lang=js"
export * from "./BbppDigitalPlatformsAS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports